module.exports = {"meta":{"description":"Yoop est une nouvelle façon d’accéder aux événements","keywords":"musique, sports, billet, événement, spectacle, concert, créateurs, fans, artiste, athlètes, équipes, billets"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src332225586/src/modules/web/src/js/i18n/french/meta.fr.i18n.json
// module id = 1228
// module chunks = 0